<template>
  <div class='row-libray'>
    <LeftListSupplier v-if="isSupplier" :pos="8"></LeftListSupplier>
    <LeftListMember v-else :pos="9"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1  m-messagecenter">
        <ul class="g-tablist1">
          <li class="li" :class="{on: search.status===undefined}">
            <a @click="search.status= undefined" class="txt">全部</a>
          </li>
          <li class="li " :class="{on: search.status===0}">
            <a @click="search.status= 0" class="txt">未读</a>
          </li>
          <li class="li " :class="{on: search.status===1}">
            <a @click="search.status= 1" class="txt">已读</a>
          </li>
        </ul>
        <div v-if="dataCount>0" class='titattention1'>共{{ dataCount }}条消息</div>
        <div class="contect g-contecte2">
          <div class="top1">
            <div class="btn" @click="batchDel">删除</div>
            <div class="btn" @click="setRead(0,1)">全部已读</div>
          </div>

          <div class="m-table m-table-messagecenter">

            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id" :columns="columns"
              :data-source="data" :pagination="false" :bordered="false">

              <div slot="content" slot-scope="content, record, indent, expanded,"
                :style="{ color: record.status==1 ? '#9FA6AF' : '#222529' }">
                <span class="desc" @click="!record.status && setRead(record.id)" :title="content">{{ content }}</span>
              </div>
              <div slot="status" slot-scope="statusOptionName, record, indent, expanded,"
                :style="{ color: record.status==1 ? '#9FA6AF' : '#222529' }">
                <span class="read" @click="!record.status && setRead(record.id)">{{ record.statusOptionName }}</span>
              </div>
              <div slot="del" class="del" slot-scope="desc, record, indent, expanded,">
                <a @click="del(record)">删除</a>
              </div>
              <!-- <div slot="tags" slot-scope="tags">
                <a-tag v-for="tag in tags" :key="tag"
                  :color="tag === '未读' ? '已读' : tag.length > 5 ? '#9FA6AF' : '#222529'">
                  {{ tag.toUpperCase() }}
                </a-tag>
              </div> -->
            </a-table>
          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import mPages from '@/components/mpages/mPages.vue'
import LeftListMember from "@/components/LeftListMember.vue";
import {getApiRes} from "@/api/apiUtil";
import apiUserMsg from "@/api/userMsg";
export default {
  components: {
    LeftListMember,
    LeftListSupplier,
    mPages,
  },
  data() {
    return {
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,

      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "全选",
          dataIndex: "order",
          key: "order",
          width: 50,
        },
        {
          title: " 时间",
          dataIndex: "createtime",
          key: "createtime",
          width: 200,
        },
        {
          title: "内容",
          dataIndex: "content",
          key: "content",
          width: 706,
          ellipsis: true,
          scopedSlots: { customRender: 'content' },

        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          width: 210,
          ellipsis: true,
          scopedSlots: { customRender: 'status' },

        },
        {
          title: "操作",
          dataIndex: "value3",
          key: "value3",
          ellipsis: true,
          width: 300,
          scopedSlots: { customRender: 'del' },
        },

      ],

      data: [],
      dataCount: 0,
      search: {
        status: undefined,
      },
      filter: {
        page: 1,
        pageSize: 20,
      },
    };
  },
  computed: {
    // container() {
    //   return bus.container;
    // },
    isSupplier(){
      return this.$store.state.user.roles.indexOf('supplier') > -1
    }
  },
  watch: {
    filter:{
      handler() {
        this.load()
      },
      deep: true
    },
    search:{
      handler() {
        this.load(1)
      },
      deep: true
    },
  },
  mounted() {
    this.load()

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }
  },
  methods: {
    async load(page = undefined){
      if(page) this.filter.page = page
      let map = this.getMap()
      let re = await getApiRes(apiUserMsg.getList(undefined,undefined,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
    },
    getMap(){
      let map = []
      if(this.search.status!== undefined) map.push(['status','=', this.search.status])
      return map
    },
    async batchDel(){
      if(this.selectedRowKeys.length==0) return this.$message.error('请选择要删除的数据')
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiUserMsg.listDel(this.selectedRowKeys),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async del(row){
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiUserMsg.listDel(row.id),0,1,1,1)
      if(re.code==0){
        let index = this.data.indexOf(row)
        this.data.splice(index,1)
      }
    },
    async setRead(id, isAll){
      let re = await getApiRes(apiUserMsg.setRead(id,isAll),0,1,0,0)
      if(isAll && re.code==0){
        this.$message.success('标记成功')
        this.data.forEach(v=>{
          v.status = 1
          v.statusOptionName = '已读'
        })
      }
      if(id){
        let index = this.data.findIndex((item)=>item.id==id)
        this.data[index].status = 1
        this.data[index].statusOptionName = '已读'
      }
    },
    // 表格
    // 搜索
    onSearch(value) {
      console.log(value);
    },
    onSubmit() {
      console.log('submit!', this.form);
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },

  },
};

</script>

<style lang="scss" scoped>
.ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}
.m-messagecenter .g-pages {
  margin: 50px 24px 0 20px;
}
</style>
